export default (data) => {
  return {
    event: 'promotionImpression',
    ecommerce: {
      promoView: {
        promotions: {
          id: 'BETA 2.0',
          name: ' MYB 2.0 ',
          creative: data.creative,
          position: ' MYB ',
        },
      },
    },
  };
};
